import { BaseConverter } from "@converter/BaseConverter";
import { AccomodationTranslation } from "@models/accomodation-translation.model";
import { AccomodationTranslationDto } from "@dtos/accomodation-translation.dto";
import { AccomodationConverter } from "./accomodationConverter";

export class AccomodationTranslationConverter extends BaseConverter<AccomodationTranslation, AccomodationTranslationDto>{
    private accomodationConverter = new AccomodationConverter()
    modelToDto(model: AccomodationTranslation): AccomodationTranslationDto {
        return new AccomodationTranslationDto(
          model.detail,
          model.locale,
          model.accomodation? this.accomodationConverter.modelToDto(model.accomodation) : undefined  
        )
    }

    dtoToModel(dto: AccomodationTranslationDto): AccomodationTranslation {
        return new AccomodationTranslation(
            dto.detail,
            dto.locale,
            dto.accomodation ? this.accomodationConverter.dtoToModel(dto.accomodation) : undefined
        )
        
    }
}